import {LoginScreen} from "@src/features/auth/components/login-screen";
import {VerifyOtpScreen} from "@src/features/auth/components/verify-otp-screen";
import * as React from "react";
import {type RouteObject} from "react-router-dom";


export type VerifyOtpState = {
	phoneNumber: string
}


export function getAuthRoutesDefinitions(): RouteObject[] {
	return [
		{
			path: "login",
			element: <LoginScreen/>,
		},
		{
			path: "verifyOtp",
			element: <VerifyOtpScreen/>,
		},
	] satisfies RouteObject[];
}
